function twoDigits(number) {
  return number < 10 ? '0' + number : number;
}

function ddMMyyyy(date) {
  return `${twoDigits(date.getDate())}.${twoDigits(date.getMonth() + 1)}.${date.getFullYear()}`;
}

function hhmm(date) {
  return `${twoDigits(date.getHours())}:${twoDigits(date.getMinutes())}`;
}

export default {
  formatDate(value) {
    let date = new Date(value);
    return ddMMyyyy(date);
  },

  formatDateTime(value) {
    let date = new Date(value);
    return `${ddMMyyyy(date)} ${hhmm(date)}`;
  }
}

